import React from "react";
import {
  Route,
  Switch,
  Redirect,
  withRouter,
} from "react-router-dom";
import classnames from "classnames";
import { withStyles } from '@material-ui/styles';

import Header from "../Header/Header";
import Sidebar from "../Sidebar/Sidebar";

// pages
import GestionePresenze from "../../pages/gestionePresenze/GestionePresenze";
import UserSettings from "../../pages/usersettings/UserSettings";
import SendFeedback from "../../pages/sendFeedback/SendFeedback";
import RotateDeviceWidget from "../../widgets/RotateDeviceWidget";
import EsameDetails from "../../pages/esameDetails/EsameDetails";
import TeacherDashboard from "../../pages/teacherDashboard/TeacherDashboard";
import TeacherCorsi from "../../pages/teacherCorsi/TeacherCorsi";
import TeacherEsami from "../../pages/teacherEsamiCorso/TeacherEsami";
import TeacherSchedule from "../../pages/teacherSchedule/TeacherSchedule";
import NotificheTeacher from '../../pages/teacherNotifiche/NotificheTeacher';
import OnlineLesson from "../../pages/onlineLesson/onlineLesson";
import translateString from "../../utils/Locales";
import { getServiceName } from "../../utils/consts";
import { ToastContainer } from 'react-toastify';
import '../Layout/ReactToastify.css';
import NewExam from "../../pages/NewExam/NewExam";
import ResultTest from "../../pages/resultTest/ResultTest";

let t = translateString;

const makeStyles = theme => ({
  root: {
    display: "flex",
    maxWidth: "100vw",
    overflowX: "hidden",
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    width: `calc(100vw - 240px)`,
    minHeight: "100vh",
  },
  contentShift: {
    width: `calc(100vw - ${240 + theme.spacing(6)}px) `,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  fakeToolbar: {
    ...theme.mixins.toolbar,
  },
});

class TeacherLayout extends React.Component {

  constructor(props){
    super(props)

    this.state = {
      menuItems: []
    }
  }

  handleResize() {
    if (window.innerWidth < 768 && window.innerHeight > window.innerWidth ) {
      this.setState({ isPortrait: true });
    } else {
      this.setState({ isPortrait: false });
    }
  }

  componentDidMount(){
    window.addEventListener('resize', this.handleResize.bind(this));
    this.handleResize();
    window.document.title = getServiceName() + ' - ' + t('professore').charAt(0) + t('professore').toLowerCase().slice(1);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize.bind(this));
  }


  render (){

    // global
    const { classes } = this.props;

    if (this.state.isPortrait) return <RotateDeviceWidget />;

    return (
      
      <div className={classes.root}>
          <>
            <Header history={this.props.history} />
            <Sidebar menuItems={this.state.menuItems}/>
            <ToastContainer style={{ marginTop: 60 }} />
            <div
              className={classnames(classes.content, {
                [classes.contentShift]: null,
              })}
            >
              <div className={classes.fakeToolbar} />
              
                <Switch>

                  <Route path="/app/dashboard" component={TeacherDashboard} />
                  <Route path="/app/corsi" component={TeacherCorsi} />
                  <Route path="/app/esamiCorso" component={TeacherEsami} />
                  <Route path="/app/esameDetails" component={EsameDetails} />
                  <Route path="/app/notifiche" component={NotificheTeacher} />
                  <Route path="/app/schedule" component={TeacherSchedule} />
                  <Route path="/app/gestionePresenze" component={GestionePresenze} />
                  <Route path="/app/userSettings" component={UserSettings} />
                  <Route path="/app/lesson" component={OnlineLesson} />
                  <Route path="/app/nuovoEsame" component={NewExam} />
                  <Route path="/app/risultatiEsame" component={ResultTest} />

                  <Route
                    exact
                    path="/app/ui"
                    render={() => <Redirect to="/app/ui/icons" />}
                  />
                </Switch>
            </div>
            <div
              className={classnames(classes.contentPhone)}
            >
            </div>
            <div className="lang-btn" style={{ position: 'fixed', top: 25, right: 150, zIndex: 2000 }} onClick={() => { this.setState({ }); window.sessionStorage.setItem('lang', 'it') }}><img src={ require('../../images/it.png') } style={{ width: 20, height: 'auto' }}/></div>
            <div className="lang-btn" style={{ position: 'fixed', top: 25, right: 120, zIndex: 2000 }} onClick={() => { this.setState({ }); window.sessionStorage.setItem('lang', 'en') }}><img src={ require('../../images/en.png') } style={{ width: 20, height: 'auto' }}/></div>
          </>
      </div>
    );
  }
  
}

export default withStyles(makeStyles)(withRouter(TeacherLayout));
